// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__5Ce9I","vLegacy":"SelectSecondary_vLegacy__1kEcM","error":"SelectSecondary_error__2ixGh","disabled":"SelectSecondary_disabled__3irEx"};